import React from "react";
import { useEffect, useState } from "react";
import "./gallery.css";
import EventImages from "./EventImages.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Gallery(props) {
  const { eventImage, setEventImage, classUpdate, setClassUpdate } = props;

  // const [eventImage, setEventImage] = useState("All");

  // const [classUpdate, setClassUpdate] = useState("All");
  var nameArr = [
    "All",
    "Wedding",
    "Corporate Event",
    "birthday",
    "Destination Wedding",
    "Haldi Mehndi Sangeet",
    "Anniversary",
    "Cocktail Party",
    "Surprise Parties",
  ];

  const handleClick = (e) => {
    setEventImage(e.target.id);

    if (document.getElementById(e.target.id)) {
      setClassUpdate(e.target.id);
      document.getElementById(e.target.id).style.background = "red";
      document.getElementById(e.target.id).className = "gallery_clicked_event";

      // if (document.getElementById(e.target.id)) {
      //   document.getElementById(e.target.id).style.background = "red";
      //   document.getElementById(e.target.id).className =
      //     "gallery_clicked_event";
      // }
    }
  };

  const slider = React.useRef(null);

  const settings = {
    className: "sldi",
    arrow: true,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,

    cssEase: "linear",
    pauseOnHover: true,
    // centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2,
          //   arrow: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          //   arrows: false,
        },
      },
    ],
  };

  return (
    <div id={"gallery"} className="container">
      <p className="container_heading">
        <span className="heading_first">Gallery</span>
      </p>

      <Slider ref={slider} {...settings} className="gallery_events">
        <p
          id="All"
          className={
            classUpdate !== "All"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          All
        </p>

        <p
          id="Wedding"
          className={
            classUpdate !== "Wedding"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Wedding
        </p>

        <p
          id="Corporate Event"
          className={
            classUpdate !== "Corporate Event"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Corporate Event
        </p>
        <p
          id="Birthday"
          className={
            classUpdate !== "Birthday"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Birthday
        </p>

        <p
          id="Destination Wedding"
          className={
            classUpdate != "Destination Wedding"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Destination Wedding
        </p>
        <p
          id="Haldi Mehndi Sangeet"
          className={
            classUpdate != "Haldi Mehndi Sangeet"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Haldi Mehndi Sangeet
        </p>
        <p
          id="Anniversary"
          className={
            classUpdate != "Anniversary"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Anniversary
        </p>

        <p
          id="Cocktail Party"
          className={
            classUpdate != "Cocktail Party"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Cocktail Party
        </p>

        <p
          id="Surprise Parties"
          className={
            classUpdate != "Surprise Parties"
              ? "galler_event_name"
              : "gallery_clicked_event"
          }
          onClick={handleClick}
        >
          Surprise Parties
        </p>
      </Slider>

      {eventImage ? <EventImages name={eventImage} /> : null}
    </div>
  );
}

export default Gallery;
